/* =========================================================================
   RELOAD — theme.js
   The original prototype was a single-page app. A Shopify theme has real
   URLs and a server-side cart, so the router and the in-memory cart are gone.
   Everything else — carousel, gallery, size guide, toast, mobile shell — is
   kept and re-wired to Shopify's AJAX Cart API.
   ========================================================================= */
(function () {
  'use strict';

  var money = function (cents) {
    return window.RELOAD_MONEY_FORMAT
      ? window.RELOAD_MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      : (cents / 100).toFixed(2);
  };

  /* ---------------------------------------------------------------- toast */
  var TICK = '<svg class="tick" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';
  function showToast(msg, opts) {
    var stack = document.getElementById('toastStack');
    if (!stack) return;
    opts = opts || {};
    var el = document.createElement('div');
    el.className = 'toast' + (opts.warn ? ' warn' : '');
    el.innerHTML = (opts.warn ? '' : TICK) + '<span>' + msg + '</span>' +
      (opts.href ? '<a href="' + opts.href + '">' + opts.label + '</a>' : '');
    stack.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('in'); });
    while (stack.children.length > 3) stack.removeChild(stack.firstChild);
    setTimeout(function () {
      el.classList.remove('in');
      setTimeout(function () { el.remove(); }, 260);
    }, opts.warn ? 4200 : 3000);
  }
  window.showToast = showToast;

  function announce(msg) {
    var el = document.getElementById('liveAnnouncer');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  }

  /* ------------------------------------------------------- mobile menu */
  (function () {
    var nav = document.getElementById('mobileNav');
    var backdrop = document.getElementById('navBackdrop');
    var burger = document.getElementById('burgerBtn');
    var closeBtn = document.getElementById('mobileNavClose');
    if (!nav || !backdrop) return;

    function setOpen(open) {
      nav.classList.toggle('open', open);
      backdrop.classList.toggle('on', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open && closeBtn) setTimeout(function () { closeBtn.focus(); }, 0);
    }
    if (burger) burger.addEventListener('click', function () { setOpen(!nav.classList.contains('open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('open')) setOpen(false);
    });
    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = [].slice.call(nav.querySelectorAll('a, button')).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* ---------------------------------------------------------- carousel */
  (function () {
    var root = document.getElementById('heroCarousel');
    if (!root) return;
    var slides = [].slice.call(root.querySelectorAll('.hc-slide'));
    if (slides.length < 2) return;
    var dotsWrap = document.getElementById('hcDots');
    var idx = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'hc-dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Slide ' + (i + 1));
      d.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(d);
    });
    var dots = [].slice.call(dotsWrap.children);

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }
    function restart() { if (reduce) return; clearInterval(timer); timer = setInterval(next, 6000); }

    var nx = document.getElementById('hcNext'), pv = document.getElementById('hcPrev');
    if (nx) nx.addEventListener('click', function () { next(); restart(); });
    if (pv) pv.addEventListener('click', function () { prev(); restart(); });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); restart(); }
      x0 = null;
    });
    restart();
  })();

  /* -------------------------------------------------------- accordions */
  document.querySelectorAll('.acc-head, .fgroup-head').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.parentElement.classList.toggle('open'); });
  });

  /* -------------------------------------------------------- size guide */
  (function () {
    var modal = document.getElementById('sizeGuide');
    var openBtn = document.getElementById('sizeGuideOpen');
    var closeBtn = document.getElementById('sizeGuideClose');
    var content = document.getElementById('sizeGuideContent');
    if (!modal || !openBtn) return;

    var CLOTHING = {
      head: ['Size', 'Chest', 'Waist', 'Shoulder', 'Length'],
      rows: [['XS', '92 cm', '76 cm', '42 cm', '66 cm'], ['S', '98 cm', '82 cm', '44 cm', '68 cm'],
             ['M', '104 cm', '88 cm', '46 cm', '70 cm'], ['L', '110 cm', '94 cm', '48 cm', '72 cm'],
             ['XL', '116 cm', '100 cm', '50 cm', '74 cm']]
    };
    var FOOTWEAR = {
      head: ['EU', 'UK', 'US', 'Foot length'],
      rows: [['38', '5', '6', '24.0 cm'], ['39', '6', '7', '24.7 cm'], ['40', '6.5', '7.5', '25.3 cm'],
             ['41', '7.5', '8.5', '26.0 cm'], ['42', '8', '9', '26.7 cm'], ['43', '9', '10', '27.3 cm'],
             ['44', '9.5', '10.5', '28.0 cm'], ['45', '10.5', '11.5', '28.7 cm']]
    };
    var ACCESSORY = { head: ['Size', 'Fits'], rows: [['OS', 'One size — measurements listed on the piece']] };

    function table(d) {
      return '<div class="size-scroll"><table class="size-table"><thead><tr>' +
        d.head.map(function (x) { return '<th>' + x + '</th>'; }).join('') +
        '</tr></thead><tbody>' +
        d.rows.map(function (r) { return '<tr>' + r.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>'; }).join('') +
        '</tbody></table></div>';
    }

    var lastFocus = null;
    function open() {
      var labels = [].slice.call(document.querySelectorAll('#pdpSizes .size-btn')).map(function (b) { return b.textContent.trim(); });
      var data = labels.some(function (l) { return /^\d+$/.test(l); }) ? FOOTWEAR
               : labels.indexOf('OS') > -1 ? ACCESSORY : CLOTHING;
      content.innerHTML = table(data);
      lastFocus = document.activeElement;
      modal.classList.add('open');
      closeBtn.focus();
    }
    function close() { modal.classList.remove('open'); if (lastFocus) lastFocus.focus(); }

    openBtn.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
      if (e.key === 'Tab' && modal.classList.contains('open')) { e.preventDefault(); closeBtn.focus(); }
    });
  })();

  /* ------------------------------------------------- product gallery */
  (function () {
    var main = document.getElementById('pdpMain');
    if (!main) return;
    var thumbs = document.getElementById('pdpThumbs');

    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var t = e.target.closest('.pdp-thumb');
        if (!t) return;
        thumbs.querySelectorAll('.pdp-thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var img = main.querySelector('img');
        var src = t.getAttribute('data-full');
        if (img && src) { img.src = src; img.srcset = ''; }
      });
    }

    var coarse = window.matchMedia('(pointer:coarse)').matches;
    var hint = document.createElement('div');
    hint.className = 'pdp-zoom-hint';
    hint.textContent = coarse ? 'Tap to zoom' : 'Click to zoom';
    main.appendChild(hint);

    function pan(x, y) {
      var r = main.getBoundingClientRect();
      var img = main.querySelector('img');
      if (img) img.style.transformOrigin =
        Math.min(100, Math.max(0, (x - r.left) / r.width * 100)) + '% ' +
        Math.min(100, Math.max(0, (y - r.top) / r.height * 100)) + '%';
    }
    main.addEventListener('click', function () {
      if (!main.querySelector('img')) return;
      main.classList.toggle('zoomed');
      hint.textContent = main.classList.contains('zoomed')
        ? (coarse ? 'Tap to exit' : 'Click to exit')
        : (coarse ? 'Tap to zoom' : 'Click to zoom');
    });
    main.addEventListener('mousemove', function (e) { if (main.classList.contains('zoomed')) pan(e.clientX, e.clientY); });
    main.addEventListener('touchstart', function (e) { if (main.classList.contains('zoomed')) pan(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    main.addEventListener('touchmove', function (e) {
      if (!main.classList.contains('zoomed')) return;
      e.preventDefault();
      pan(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });
    main.addEventListener('mouseleave', function () {
      if (coarse) return;
      main.classList.remove('zoomed');
      hint.textContent = 'Click to zoom';
    });
  })();

  /* ------------------------------------------------- variant picking */
  (function () {
    var form = document.getElementById('productForm');
    if (!form) return;
    var variants = window.RELOAD_VARIANTS || [];
    var idInput = document.getElementById('variantId');
    var priceEl = document.getElementById('pdpPrice');
    var labelEl = document.getElementById('pdpSizeLabel');
    var addBtn = document.getElementById('pdpCart');
    var addLabel = document.getElementById('pdpCartLabel');
    var mbAction = document.getElementById('mbAction');
    var mbLabel = document.getElementById('mbLabel');

    function select(btn) {
      var v = variants.filter(function (x) { return String(x.id) === btn.dataset.variant; })[0];
      if (!v || !v.available) return;
      form.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
      idInput.value = v.id;
      if (labelEl) labelEl.textContent = v.title;
      if (priceEl && v.price != null) priceEl.textContent = money(v.price);
      if (addBtn) addBtn.disabled = false;
      if (addLabel) addLabel.textContent = 'Add to bag';
      if (mbLabel) mbLabel.textContent = 'Size ' + v.title;
      if (mbAction) mbAction.disabled = false;
    }

    form.querySelectorAll('.size-btn').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); select(b); });
    });

    var only = form.querySelectorAll('.size-btn:not([disabled])');
    if (only.length === 1) select(only[0]);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput.value) {
        if (addLabel) addLabel.textContent = 'Select a size first';
        showToast('Select a size first', { warn: true });
        return;
      }
      addBtn.disabled = true;
      var prev = addLabel ? addLabel.textContent : '';
      if (addLabel) addLabel.textContent = 'Adding…';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) {
            if (addLabel) addLabel.textContent = prev;
            showToast(res.d.description || 'Could not add that piece', { warn: true });
            return;
          }
          if (addLabel) addLabel.textContent = 'Added to bag';
          announce('Added to bag');
          showToast('Added to bag', { href: window.Shopify.routes.root + 'cart', label: 'View bag' });
          refreshCartCount();
        })
        .catch(function () {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = prev;
          showToast('Network problem — try again', { warn: true });
        });
    });
  })();

  /* ------------------------------------------------------------ cart */
  function refreshCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.getElementById('cartCount');
        if (!badge) return;
        badge.textContent = cart.item_count;
        badge.classList.toggle('on', cart.item_count > 0);
      })
      .catch(function () { /* leave the server-rendered count alone */ });
  }
  window.refreshCartCount = refreshCartCount;

  (function () {
    var lines = document.getElementById('cartLines');
    if (!lines) return;

    function change(key, qty) {
      lines.style.opacity = '.5';
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          lines.style.opacity = '1';
          showToast('Could not update the bag', { warn: true });
        });
    }

    lines.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-inc]'),
          dec = e.target.closest('[data-dec]'),
          rm = e.target.closest('[data-remove]');
      if (inc) change(inc.dataset.inc, Number(inc.dataset.qty) + 1);
      if (dec) change(dec.dataset.dec, Number(dec.dataset.qty) - 1);
      if (rm) change(rm.dataset.remove, 0);
    });
  })();

  /* --------------------------------------------- free shipping goal */
  (function () {
    var box = document.getElementById('shipGoal');
    if (!box) return;
    var goal = Number(box.dataset.goal || 0);
    var subtotal = Number(box.dataset.subtotal || 0);
    if (!goal) return;
    var left = goal - subtotal;
    var pct = Math.max(0, Math.min(100, subtotal / goal * 100));
    box.classList.toggle('done', left <= 0);
    document.getElementById('shipGoalFill').style.width = pct + '%';
    document.getElementById('shipGoalMsg').innerHTML = subtotal === 0
      ? 'Free shipping on orders over <b>' + money(goal) + '</b>'
      : left <= 0 ? 'Free shipping unlocked'
                  : 'Add <b>' + money(left) + '</b> more for free shipping';
  })();

  /* ------------------------------------------------ collection tools */
  (function () {
    var sort = document.getElementById('shopSort');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location = u.toString();
    });

    var zone = document.getElementById('filterZone');
    var toggle = document.getElementById('filterToggle');
    if (zone && toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = zone.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!zone.contains(e.target)) {
          zone.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zone.classList.remove('open');
      });
    }

    var az = document.querySelectorAll('.az');
    var blocks = document.querySelectorAll('.letter-block');
    if (az.length) {
      az.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          var L = b.dataset.letter;
          az.forEach(function (x) { x.classList.toggle('on', x === b); });
          blocks.forEach(function (bl) {
            bl.style.display = (L === 'all' || bl.dataset.letter === L) ? '' : 'none';
          });
        });
      });
    }
  })();

  /* ------------------------------------------------- auction countdown */
  (function () {
    var cards = document.querySelectorAll('[data-auction-end]');
    if (!cards.length) return;

    function fmt(ms) {
      if (ms <= 0) return 'ENDED';
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400);
      if (d >= 1) return d + 'D ' + Math.floor(s % 86400 / 3600) + 'H LEFT';
      var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
    }
    function tick() {
      cards.forEach(function (card) {
        var end = Date.parse(card.dataset.auctionEnd);
        if (isNaN(end)) return;
        var left = end - Date.now();
        var el = card.querySelector('.countdown');
        if (el) el.textContent = fmt(left);
        if (left <= 0 && !card.classList.contains('ended')) {
          card.classList.add('ended');
          var pill = card.querySelector('.live-pill');
          if (pill) pill.innerHTML = 'Ended';
          card.querySelectorAll('.auction-bottom .btn').forEach(function (b) { b.disabled = true; });
        }
      });
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* -------------------------------------------------- mobile action bar */
  (function () {
    var bar = document.getElementById('mobileBar');
    if (!bar) return;
    var mode = bar.dataset.mode;
    var action = document.getElementById('mbAction');
    if (!mode) return;
    bar.classList.add('on');
    document.body.classList.add('has-bar');
    if (action) action.addEventListener('click', function () {
      if (mode === 'product') {
        var f = document.getElementById('productForm');
        if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
      } else if (mode === 'cart') {
        var c = document.getElementById('cartCheckout');
        if (c) c.click();
      }
    });
  })();

  /* --------------------------------------------------- inline validation */
  (function () {
    var RULES = {
      email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); },
      tel: function (v) { return v.replace(/[^0-9]/g, '').length >= 10; },
      text: function (v) { return v.length > 0; }
    };
    document.querySelectorAll('.field input[required], .field textarea[required]').forEach(function (el) {
      el.addEventListener('blur', function () {
        if (!el.value.trim()) return;
        var test = RULES[el.type] || RULES.text;
        el.closest('.field').classList.toggle('bad', !test(el.value.trim()));
      });
      el.addEventListener('input', function () {
        var f = el.closest('.field');
        if (!f.classList.contains('bad')) return;
        var test = RULES[el.type] || RULES.text;
        if (test(el.value.trim())) f.classList.remove('bad');
      });
    });
  })();

  /* ------------------------------------------------- showroom booking */
  (function () {
    var box = document.getElementById('booker');
    var frame = document.getElementById('bookerFrame');
    if (!box || !frame) return;
    var loaded = false;
    frame.addEventListener('load', function () { loaded = true; });
    setTimeout(function () { if (!loaded) box.classList.add('failed'); }, 4000);
  })();

  refreshCartCount();
})();
